<template>
  <div>
    <GenericReport
      v-if="value.organizationId != -1 && value.vehicleId != null"
      ref="report"
      class="maxh-1bar clean-list"
      hide-header
      orientation="horizontal"
      :reportSpec="reportSpec"
      :adapterSpec="adapterSpec"
      :fetcher="fetchData"
      :extraParams="{ vehicleIds: value.vehicleId }"
      @rowClicked="showRowDetails"
    />
    <OJumbo question v-else>
      Este módulo não está associado a nenhum veículo ou organização.
    </OJumbo>
  </div>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { fullSpec } from '../../vehicle/occur-columns'
import { OrgApi } from '@/models'
import moment from 'moment'

export default {
  tabTitle: 'Ocorrências',
  tabGroup: 'Veículo',
  tabBadgeFn: async (client) => {
    let orgId = client.organizationId
    let vehicleId = client.vehicleId
    if (vehicleId == null) return null

    let res = await new OrgApi(orgId).get('occurrences', {
      vehicleIds: vehicleId,
      fromDate: moment()
        .add(-15, 'd')
        .toDate(),
      untilDate: new Date(),
      type: 'infraction',
      limit: 1
    })

    if (res.count != 0) {
      return {
        text: res.count,
        color: 'red',
        alt: '(infrações nos últimos 15 dias)'
      }
    }
  },
  components: {
    GenericReport
  },
  props: {
    value: { required: true }
  },
  data() {
    return { adapterSpec: fullSpec }
  },
  computed: {
    reportSpec() {
      let orgId = this.value.organizationId
      return {
        code: 'occurs',
        title: 'Ocorrências',
        filters: [
          'DateRange',
          {
            type: 'OccurConfig',
            label: 'Tipos de Ocorrência',
            prefix: 'config',
            orgId
          }
        ]
      }
    }
  },
  methods: {
    fetchData(apiParams) {
      let fetcher = new OrgApi(this.value.organizationId)
      let ps = {...apiParams}
      if ( apiParams.configIds == null || apiParams.configIds.length < 1 )
        ps.type = 'infraction'

      return fetcher.get('/occurrences', ps)
    },

    async showRowDetails({ row }) {
      let fetcher = new OrgApi(this.value.organizationId)
      let occur = await fetcher.get('/occurrences/' + row.id)

      this.$vis({
        tripId: occur.startTripId,
        orgId: this.value.organizationId
      })
    }
  }
}
</script>

<style></style>
